import _ from "lodash";
import Radium from "radium";
import React from "react";

import { Remo } from "@components";
import { listStyles } from "@common/styles";
import { IApiKey } from "@common/models";
import ApiKeyList from "./api-key-list";
import EditApiKey from "./edit-api-key";

export interface IApiKeyProps {
  userId: string;
  apiKeys: IApiKey[];
}

export interface IApiKeyActions {
  updateApiKeys: (
    userId: string,
    newDate: string,
    newName: string,
    oldName: string
  ) => void;
  createApiKey: (userId: string) => void;
  deleteApiKey: (userId: string, tokenName: string) => void;
}

export interface IApiKeyState {
  apiKey: IApiKey;
}

class ApiKeys extends React.Component<
  IApiKeyProps & IApiKeyActions,
  IApiKeyState
> {
  constructor(props) {
    super(props);
    this.state = { apiKey: null };
  }

  public render() {
    const rowStyle = { ...listStyles.row, alignItems: "left" };
    const listItemStyle = { ...listStyles.listItem, fontSize: "13px" };
    const editLinkStyle = {
      ...listItemStyle,
      justifyContent: "flex-end",
      width: "20%",
      flex: "1"
    };

    const { apiKeys, userId } = this.props;
    const userHasApiKeys = !!apiKeys && apiKeys.length > 0;
    return (
      <div>
        <div style={listStyles.rowHeader as any} className="rowHeader">
          <div style={listItemStyle as any}>API-nøkler</div>
        </div>
        <div style={rowStyle as any} className="row">
          <ApiKeyList
            apiKeys={apiKeys}
            editApiKey={apiKey => this.setState({ apiKey })}
          />
          <div style={userHasApiKeys ? { display: "none" } : editLinkStyle}>
            <div
              onClick={() => this.props.createApiKey(userId)}
              style={listStyles.listLinkStyle as any}
            >
              Opprett API-nøkkel
            </div>
          </div>
        </div>
        <Remo show={!!this.state.apiKey}>
          <EditApiKey
            updateApiKey={this.updateApiKey}
            closeModal={() => this.setState({ apiKey: null })}
            deleteApiKey={this.deleteApiKey}
            apiKey={apiKeys[0]}
          />
        </Remo>
      </div>
    );
  }

  private deleteApiKey = () => {
    const {
      apiKey: { tokenName }
    } = this.state;
    this.setState({ apiKey: null }, () =>
      this.props.deleteApiKey(this.props.userId, tokenName)
    );
  };

  private updateApiKey = (tokenName: string, expireDate: string) => {
    const { apiKey } = this.state;
    this.setState({ apiKey: null }, () => {
      const newTokenName = tokenName || apiKey.tokenName,
        newExpireDate = expireDate || apiKey.expireDate;

      if (
        newTokenName === apiKey.tokenName &&
        newExpireDate === apiKey.expireDate
      ) {
        return;
      }

      this.props.updateApiKeys(
        this.props.userId,
        expireDate || apiKey.expireDate,
        tokenName || apiKey.tokenName,
        apiKey.tokenName
      );
    });
  };
}

export default Radium(ApiKeys);
